<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :width="width"
    @close="handleClose"
    :close-on-click-modal="closeOnClickOutsideOrEscape"
    :close-on-press-escape="closeOnClickOutsideOrEscape"
    :show-close="showClose"
  >
    <template #title>
      <h3 class="modal-title">{{ title }}</h3>
    </template>
    <div class="content">
      <slot></slot>
    </div>
    <template #footer>
      <div class="modal-footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "Modal",
  props: {
    title: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
    closeOnClickOutsideOrEscape: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: "400px"
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.modal-title {
  margin-bottom: 2px;
  font-size: 18px;
}

.content {
  max-width: 100%;
  word-break: normal;
  overflow-wrap: break-word;
}

::v-deep .el-dialog {
  border-radius: 16px;
  overflow: hidden;
  background: rgb(236, 236, 236);
}

::v-deep .el-dialog__body {
  border-top: 1px solid #d4d4d4;
  border-bottom: 1px solid #d4d4d4;
  padding: 16px 20px;
  overflow: visible;
  max-height: none;
}

::v-deep .el-dialog__footer {
  overflow: visible;
}

::v-deep .el-dialog__headerbtn i {
  color: #295661;
  font-size: 20px;
}

::v-deep .el-dialog__headerbtn i:hover {
  color: #1d6eba;
}
</style>
